<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">{{ title }}</v-toolbar-title>
    </v-toolbar>
    <v-card class="spacing-top" v-if="loading">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </v-card>
    <v-card class="spacing-top px-2 custom-font-regular" v-else>
      <v-card-text>
        <div class="title-form mt-2">Archivos adjuntos asociados</div>
        <v-divider class="mt-2 mb-3"></v-divider>
        <p class="red--text mr-3" v-for="error in fileErrors" :key="error">{{ error }}</p>
        <div class="mx-2">
          <AttachFile ref="fileInput" @upload="uploadFiles" description></AttachFile>
          <v-tooltip bottom>
            <v-btn color="grey" depressed class="square-button" slot="activator" @click="openFileDirectory">
              <v-icon color="grey darken-3">add</v-icon>
            </v-btn>
            <span>Agregar adjunto</span>
          </v-tooltip>
        </div>
        <v-divider class="mt-5 mb-2"></v-divider>
        <ConfirmationDialog :function-yes="bindingFunction" ref="confirm" title="Abandonar página"
                            text="Se perderán los cambios del formulario actual, ¿desea continuar?"></ConfirmationDialog>
        <v-card-actions>
          <v-btn color="grey" depressed :disabled="saving" @click="goBackConfirmation">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="uploadAllFiles" depressed color="primary" :disabled="saving">Enviar</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import AttachFile from '../../../common/ui/AttachFile'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'

export default {
  mixins: [validationMixin, createEntityMixin, s3UploadMixin],

  props: {
    title: {
      type: String,
      default: 'Nueva apelación'
    },
    prefixCreatePath: {
      type: String,
      default: 'case_file/appeal/'
    }
  },

  validations () {
    return {
      files: { required: requiredIf(() => { return !this.isEditing }) }
    }
  },

  components: {
    AttachFile,
    ConfirmationDialog
  },

  data () {
    return {
      axiosMethod: this.axios.put
    }
  },

  computed: {
    isEditing () {
      return false
    },
    fileErrors () {
      return this.getRequiredErrors('files', 'Adjunto requerido.')
    },
    createPath () {
      return this.prefixCreatePath + this.$route.params.id
    }
  },

  methods: {
    getPayload () {
      return {
        'assets': this.assets
      }
    },
    isValidForm () {
      return !this.$v.$invalid
    }
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 6em !important;
}
.title-form {
  font-size: 1.3em;
}
.square-button {
  margin: 0.5em 0 0 0;
  padding: 0 !important;
  width: 2em !important;
  height: 2em;
  min-width: 20px;
}
</style>
